"use client";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { QrisPaymentStep } from "@/components/payments/qris-payment-step";
import { GuestCheckoutIdleStep } from "@/components/offer/guest-checkout-idle-step";
import { GuestCheckoutOauthStep } from "@/components/offer/guest-checkout-oauth-step";
import { useGuestCheckoutFlow } from "@/components/offer/use-guest-checkout-flow";
import { cn } from "@/lib/utils";

export function GuestBundleCheckoutDialog({
  open,
  onOpenChange,
  amount,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  amount: number;
}) {
  const flow = useGuestCheckoutFlow({ open, amount, onOpenChange });

  return (
    <Dialog open={open} onOpenChange={flow.handleOpenChange}>
      <DialogContent
        closeLabel={flow.copy.close}
        className={cn(
          "max-h-[calc(100dvh-2rem)] overflow-y-auto sm:max-w-md",
          flow.step === "qr" && "sm:max-w-2xl",
        )}
      >
        {flow.step === "oauth" ? (
          <GuestCheckoutOauthStep
            error={flow.error}
            onGoogleLogin={flow.handleGoogleLogin}
          />
        ) : flow.step === "qr" && flow.qrData ? (
          <>
            <DialogHeader>
              <DialogTitle>{flow.copy.checkoutTitle}</DialogTitle>
              <DialogDescription>{flow.copy.tagline}</DialogDescription>
            </DialogHeader>
            <QrisPaymentStep
              paymentId={flow.qrData.paymentId}
              qrString={flow.qrData.qrString}
              invoiceUrl={flow.qrData.invoiceUrl}
              amount={flow.qrData.amount}
              labels={flow.dictionary.payment.qris}
              claimToken={flow.qrData.claimToken}
              layout="split"
              onSuccess={flow.handlePaymentSuccess}
              onRetry={flow.handleRetry}
              onTerminalState={flow.handleTerminalState}
            />
          </>
        ) : (
          <>
            <DialogHeader>
              <DialogTitle>{flow.copy.checkoutTitle}</DialogTitle>
              <DialogDescription>{flow.copy.tagline}</DialogDescription>
            </DialogHeader>
            <GuestCheckoutIdleStep
              amount={amount}
              email={flow.email}
              emailError={flow.emailError}
              error={flow.error}
              isStarting={flow.isStarting}
              startingLabel={flow.copy.starting}
              onEmailChange={flow.onEmailChange}
              onSubmit={flow.startCheckout}
            />
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
